module.exports = __webpack_public_path__ + "assets/38390dec3aaadd18b55c2baeba0e6415.png";